<template>
  <div class="edit-qr-container">
    <div class="qr-edit-header">
      Qr ویرایش
    </div>
    <div class="qr-creator-container">
      <div style="width: 100%;">
        <div class="qr-color-picker">
          <div class="qr-div-titles">:Qr رنگ</div>
          <el-color-picker
              v-model="qrColorValue"
              color-format="rgb"
              :predefine="predefineColors"
          />
          <div v-if="qrColorErrorMessage" class="edit-qr-color-error">
            {{ qrColorErrorMessage }}
          </div>
        </div>

        <div class="qr-color-picker">
          <div class="qr-div-titles">:رنگ زمینه</div>
          <el-color-picker
              v-model="qrBackgroundValue"
              color-format="rgb"
              :predefine="predefineBackgroundColors"
          />
          <div v-if="qrBackgroundErrorMessage" class="edit-qr-background-error">
            {{ qrBackgroundErrorMessage }}
          </div>
        </div>

      </div>
      <div class="qr-buttons edit-qr-button">
        <el-button class="login-button" type="primary" @click="sendEditQr" :loading="sendQrLoading">
          ثبت
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>


import axios from "axios";
const baseUrl = 'https://magic.payamakapi.ir/api/v1/quickSMSQR';
const validateQr = '/EditQr'

export default {
  name: "QrWidgetConfig",
  components: {},
  props: {
    element: {}
  },
  data() {
    return {
      predefineColors: [
        'rgb(126, 19, 19)',
        'rgb(17, 50, 107)',
        'rgb(5, 56, 40)',
        'rgb(0, 0, 0)'
      ],
      predefineBackgroundColors: [
        'rgb(212, 236, 234)',
        'rgb(213, 229, 242)',
        'rgb(236, 236, 236)',
        'rgb(243, 218, 218)',
        'rgb(255, 255, 255)',
      ],
      qrBackgroundValue: 'rgb(212, 236, 234)',
      qrColorValue: 'rgb(126, 19, 19)',
      qrBackgroundErrorMessage: '',
      qrColorErrorMessage: '',
      sendQrLoading: false
    }
  },
  methods: {
    base64ToFile(base64String, fileName, contentType) {
      const byteCharacters = atob(base64String);
      const byteArrays = [];
      const sliceSize = 512;

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, {type: contentType});
      return new File([blob], fileName, {type: contentType});
    },
    sendEditQr() {
      if(this.qrBackgroundValue && this.qrColorValue) {
        this.qrBackgroundErrorMessage = '';
        this.qrColorErrorMessage = '';
        this.sendQrLoading = true;
        const colorValue = this.qrColorValue;
        const backgroundValue = this.qrBackgroundValue;
        const validRgb = colorValue.startsWith('rgb') ? colorValue.substring(4, colorValue.length - 1) : colorValue;
        const validRgbBackground = backgroundValue.startsWith('rgb') ? backgroundValue.substring(4, backgroundValue.length - 1) : backgroundValue;
        const validQrId = this.qrId || localStorage.getItem('QrId');

        axios.post(baseUrl + validateQr, {
          SMSQrId: validQrId,
          UserId: localStorage.getItem('UserId'),
          ReceiverNumber: JSON.parse(localStorage.getItem('QrList')).find(qrList => {
            if (qrList.SMSQrId == localStorage.getItem('QrId')) {
              return qrList
            }
          }).ReceiverNumber,
          QRForColor: validRgb,
          QRBackgroundColor: validRgbBackground
        }).then(res => {
          if (res.data.Success) {
              this.qr = res.data.Qr
              var data = new FormData();
              data.append("file", this.base64ToFile(this.qr, 'my-image.jpg', 'image'));
              axios.post(baseUrl + '/uploadImage', data).then(response => {
                this.$emit('changeConfig', {
                  props: 'image',
                  value: response.data.ImageUrl,
                  id: this.element.id
                })
                this.sendQrLoading = false;
                this.$notify.success({
                  title: "موفق",
                  message: res.data.Message,
                  offset: 100,
                  duration: 3000
                });
              })
          } else {
            this.sendQrLoading = false;
            this.$notify.error({
              title: "ناموفق",
              message: res.data.ErrorMessage,
              offset: 100,
              duration: 3000,
            });
          }
        })
      }
      else {
        if(!this.qrColorValue) {
          this.qrColorErrorMessage = 'انتخاب رنگ الزامیست'
        }
        else {
          this.qrColorErrorMessage = ''
        }
        if(!this.qrBackgroundValue) {
          this.qrBackgroundErrorMessage = 'انتخاب رنگ الزامیست'
        }
        else {
          this.qrBackgroundErrorMessage = ''
        }
      }
    }
  }
}
</script>

<style scoped>

</style>

if(!this.qrBackgroundValue && !this.qrColorValue) {
this.qrBackgroundErrorMessage = 'انتخاب رنگ الزامیست'
this.qrColorErrorMessage = 'انتخاب رنگ الزامیست'
}
if(!this.qrBackgroundValue) {
this.qrBackgroundErrorMessage = 'انتخاب رنگ الزامیست'
} else {
this.qrBackgroundErrorMessage = ''
}
if(!this.qrColorValue) {
this.qrColorErrorMessage = 'انتخاب رنگ الزامیست'
} else {
this.qrColorErrorMessage = ''
}
